import { observable, computed, makeObservable } from 'mobx';

import { formatDate } from 'utils/DateUtils';
import { textWithLineBreaks } from 'utils/StringUtils';

export type CommentableType = 'ticket';

export default class Comment {
  id: number;
  @observable
  text: string;
  @observable
  createdAt: Date;
  @observable
  authorName: string;

  constructor(authorName: string, id: number, text: string, createdAt: Date) {
    makeObservable(this);
    this.id = id;
    this.text = text;
    this.createdAt = createdAt;
    this.authorName = authorName;
  }

  @computed
  get creationInfo() {
    return formatDate(this.createdAt, 'MM/DD/YYYY, h:mm A');
  }

  @computed
  get textWithLineBreaks() {
    return textWithLineBreaks(this.text);
  }
}
